import { createAction } from '@reduxjs/toolkit'
import values from 'lodash/values'

import { findIdByArrayMatch, findIdByPrefixUrl } from './openedPages.utils'
import { getOpenedPages } from './persist.selectors'

export const add = createAction('[OPENED PAGES] add')
export const select = createAction('[OPENED PAGES] select')
export const remove = createAction<RemoveAttributes>('[OPENED PAGES] remove')
export const reset = createAction('[OPENED PAGES] reset')

interface RemoveAttributes {
  id: string | string[]
  nextActiveItem: string | Function | null
}

export const removeItem = ({ id, nextActiveItem }: RemoveAttributes) => (dispatch, getState) => {
  const openedPages = getOpenedPages(getState())

  let actualId

  if (typeof id === 'string') {
    actualId = findIdByPrefixUrl(openedPages.order, id)
  } else if (Array.isArray(id)) {
    actualId = findIdByArrayMatch(openedPages.order, id)
  }

  if (actualId) {
    if (values(openedPages.list).length > 1) {
      dispatch(remove({ id: actualId, nextActiveItem }))
    } else if (openedPages.list[actualId]) {
      dispatch(reset())
    }
  }
}

export const removeActive = (nextActiveItem: string) => (dispatch, getState) => {
  const openedPages = getOpenedPages(getState())
  dispatch(remove({ id: openedPages.activeItem, nextActiveItem }))
}
